import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from 'vue';
  import { useClickedAgent } from '../composables/useClickedAgent';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AgentNameCol',
  props: {
    agent: { type: String, required: true },
  },
  setup(__props) {

const props = __props

  

  const { clickedAgent, setClickedAgent } = useClickedAgent()

  const el = ref<HTMLDivElement>()

  watchEffect(() => {
    const tr = el.value?.parentElement?.parentElement
    if (!tr) { return }
    if (clickedAgent.value === props.agent) {
      tr.style.background = '#0083eb66'
    } else {
      tr.style.background = ''
    }
  })

return { __sfc: true,props, clickedAgent, setClickedAgent, el }
}

})